import { useRef, useEffect, useState, useCallback, forwardRef, useImperativeHandle } from 'react';

const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';

function generateCode(length = 6) {
  return Array.from({ length }, () =>
    CHARS[Math.floor(Math.random() * CHARS.length)]
  ).join('');
}

const CaptchaWidget = forwardRef(function CaptchaWidget({ onVerify }, ref) {
  const canvasRef = useRef(null);
  const [code, setCode]   = useState(() => generateCode());
  const [input, setInput] = useState('');

  const draw = useCallback((text) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const W = canvas.width;
    const H = canvas.height;

    ctx.fillStyle = '#eef0f5';
    ctx.fillRect(0, 0, W, H);

    for (let i = 0; i < 7; i++) {
      ctx.strokeStyle = `hsla(${Math.random() * 360}, 50%, 65%, 0.6)`;
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.lineTo(Math.random() * W, Math.random() * H);
      ctx.stroke();
    }

    for (let i = 0; i < 50; i++) {
      ctx.fillStyle = `hsla(${Math.random() * 360}, 40%, 55%, 0.5)`;
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1.2, 0, Math.PI * 2);
      ctx.fill();
    }

    const charW = W / text.length;
    text.split('').forEach((char, i) => {
      ctx.save();
      ctx.font = `bold ${22 + Math.random() * 8}px 'Courier New', monospace`;
      ctx.fillStyle = `hsl(${210 + Math.random() * 60}, 65%, 30%)`;
      ctx.translate(charW * i + charW / 2, H / 2 + 4);
      ctx.rotate((Math.random() - 0.5) * 0.45);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(char, 0, 0);
      ctx.restore();
    });
  }, []);

  useEffect(() => { draw(code); }, [code, draw]);

  const refresh = useCallback(() => {
    const next = generateCode();
    setCode(next);
    setInput('');
    onVerify(false);
  }, [onVerify]);

  useImperativeHandle(ref, () => ({ refresh }), [refresh]);

  const handleChange = (e) => {
    const val = e.target.value;
    setInput(val);
    onVerify(val === code);
  };

  return (
    <div className="captcha-widget">
      <label className="captcha-label">Security Check</label>
      <div className="captcha-image-row">
        <canvas ref={canvasRef} width={210} height={64} className="captcha-canvas" />
        <button type="button" className="captcha-refresh" onClick={refresh} title="New code">
          ↺
        </button>
      </div>
      <input
        type="text"
        className="captcha-input"
        placeholder="Type the characters above"
        value={input}
        onChange={handleChange}
        maxLength={6}
        autoComplete="off"
        spellCheck={false}
      />
    </div>
  );
});

export default CaptchaWidget;
